import React, { forwardRef, useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import * as Yup from 'yup'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { LoadingButton } from '@mui/lab'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from '@mui/material'
import { useSnackbar } from 'src/components/snackbar'
import FormProvider, { RHFTextField } from 'src/components/hook-form'
import axios from 'src/utils/axios'
import { getResponseError } from 'src/utils/laravel'
import { CloseIcon } from 'src/theme/overrides/CustomIcons'

const WEBHOOK_URL =
  'https://ms.pluguei.me/banking/api/webhooks/gateway/movingpay/a130fdbe-d865-4222-a6d8-f561357be9dc/payment?tenant=62e3bfa2-224c-469f-a5ad-26229a95f424'

const NotifyTransactionModal = forwardRef(({ onClose = () => {}, ...props }, ref) => {
  const [open, setOpen] = useState(false)
  const { enqueueSnackbar } = useSnackbar()

  const schema = Yup.object().shape({
    nsu: Yup.string().required('NSU é obrigatório'),
  })

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      nsu: '',
    },
  })

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
  } = methods

  const handleClose = useCallback(() => {
    reset()
    onClose()
    setOpen(false)
  }, [onClose, reset])

  useImperativeHandle(ref, () => ({
    open: () => setOpen(true),
    close: handleClose,
  }))

  const onSubmit = useCallback(
    async (data) => {
      try {
        await axios.post(WEBHOOK_URL, { id: data.nsu })
        enqueueSnackbar('Transação notificada com sucesso!', { variant: 'success' })
        handleClose()
      } catch (error) {
        enqueueSnackbar(getResponseError(error), { variant: 'error' })
      }
    },
    [enqueueSnackbar, handleClose]
  )

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle>Notificar Transação</DialogTitle>

        <IconButton
          onClick={handleClose}
          aria-label="close"
          sx={{
            position: 'absolute',
            right: 5,
            top: 5,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <Grid container spacing={2} mt={1} mb={1}>
            <Grid item xs={12}>
              <RHFTextField name="nsu" label="NSU da Venda" placeholder="Ex: 123456789" />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" color="inherit" onClick={handleClose}>
            Cancelar
          </Button>
          <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
            Enviar
          </LoadingButton>
        </DialogActions>
      </FormProvider>
    </Dialog>
  )
})

NotifyTransactionModal.propTypes = {
  onClose: PropTypes.func,
}

export default NotifyTransactionModal
